"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _Buttons = require("./Buttons");
Object.keys(_Buttons).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _Buttons[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _Buttons[key];
    }
  });
});
var _Prices = require("./Prices");
Object.keys(_Prices).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _Prices[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _Prices[key];
    }
  });
});
var _ProductImage = require("./ProductImage");
Object.keys(_ProductImage).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _ProductImage[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _ProductImage[key];
    }
  });
});
var _ProductInfo = require("./ProductInfo");
Object.keys(_ProductInfo).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _ProductInfo[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _ProductInfo[key];
    }
  });
});
var _ProductInfoLabel = require("./ProductInfoLabel");
Object.keys(_ProductInfoLabel).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _ProductInfoLabel[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _ProductInfoLabel[key];
    }
  });
});
var _SearchPreviewProduct = require("./SearchPreviewProduct");
Object.keys(_SearchPreviewProduct).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _SearchPreviewProduct[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _SearchPreviewProduct[key];
    }
  });
});
var _SearchPreviewProductSkeleton = require("./SearchPreviewProductSkeleton");
Object.keys(_SearchPreviewProductSkeleton).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _SearchPreviewProductSkeleton[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _SearchPreviewProductSkeleton[key];
    }
  });
});
var _Shades = require("./Shades");
Object.keys(_Shades).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _Shades[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _Shades[key];
    }
  });
});
var _Query = require("./Query");
Object.keys(_Query).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _Query[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _Query[key];
    }
  });
});
var _QueryListSection = require("./QueryListSection");
Object.keys(_QueryListSection).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _QueryListSection[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _QueryListSection[key];
    }
  });
});
var _QueryListSectionSkeleton = require("./QueryListSectionSkeleton");
Object.keys(_QueryListSectionSkeleton).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _QueryListSectionSkeleton[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _QueryListSectionSkeleton[key];
    }
  });
});
//# sourceMappingURL=index.js.map